import { useCreateQueryKeys as e } from "@maat/store-hooks";
//#region src/messageQuickActions/useMessageQuickActionQueryKeys.ts
var t = e("message-rule-quick-actions", { list: (e) => ["list", e ?? "catalog"] });
//#endregion
export { t as messageQuickActionQueryKeys };
